<template>
  <div>
    <van-popup 
      v-model="isShowUnionpayPop" 
      round
      :close-on-click-overlay="false" 
      :style="{ width: '80%' }"
      get-container="body"
    >
      <div class="content-box">
        <div class="title">银联支付重要提示</div>
        <div class="text">
          您店的营业执照已入网银联支付，重要提示如下：<br />
          一、银联商户号出现【停用】或【销号】的情况，就无法在拓客宝进行收款、提现等资金操作:<br />
          1、【停用】：连续3个月没有任何交易订单；或入网的证件资料变更。<br />
          2、【销号】：连续6个月没有任何交易订单；或门店注销营执照。<br />
          二、门店注销营业执照，银联商户号将被【销号】，必须在申请注销前完成2个事:<br />
          1、需提前7天向市场经理报备。<br />
          2、在拓客宝-【提现】功能全部提现，且确保提现资金已到账。<br />

          <div class="text-bottom">银联商户号被【销号】，未提现的资金将被银联冻结，无法提现，一切经济损失，自行承担!</div>
        </div>
        <div class="btn-box" @click="isShowUnionpayPop = false">关闭</div>
      </div>
  </van-popup>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isShowUnionpayPop: false
      }
    },
    mounted() {
      this.$api.common.checkUnionPayDialog().then(res => {
        this.isShowUnionpayPop = res.data == 'true' ? true : false
      })
    }
    
  }
</script>

<style lang="stylus" scoped>
  .content-box {
    padding: 16px;
    .title {
      text-align: center;
      font-size: 17px;
      color: #333333;
      margin-bottom: 18px;
      font-weight: bold;
    }
    .text {
      color: #333333;
      line-height: 20px;
      .text-bottom {
        margin-top: 10px;
      }
    }
    .btn-box {
      height: 38px;
      line-height: 38px;
      text-align: center;
      color: #fff;
      background: linear-gradient( 180deg, #FF8820 0%, #FF6B31 100%);
      border-radius: 4px;
      margin-top: 20px;
      font-weight: bold;
    }
  }
</style>